import { render } from "./PerformanceTarget.vue?vue&type=template&id=8b9d5d00&scoped=true"
import script from "./PerformanceTarget.vue?vue&type=script&lang=js"
export * from "./PerformanceTarget.vue?vue&type=script&lang=js"

import "./PerformanceTarget.vue?vue&type=style&index=0&id=8b9d5d00&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9d5d00"]])

export default __exports__